import React from 'react';
import { useSelector } from 'react-redux';
import Select, { components } from 'react-select';
import { groupSelectContext } from 'Common/styles/style';
import { FormattedMessage } from 'react-intl';
import { selectGroupBy } from 'store/Filters/selectors';
import { ASSETS_GROUP_BY_KEYS } from 'store/Filters/constants';
import useTheme from 'Hooks/UseTheme';

function GroupBy ({ entity, setGroupBy, clearGroupBy }) {
  const alias = 'group';
  const options = ASSETS_GROUP_BY_KEYS;
  const groupBy = useSelector((state) => selectGroupBy(entity, state));
  const { themeStyles } = useTheme();
  const SingleValue = ({ children, ...p }) => (
    components.SingleValue && (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.SingleValue { ...p }>
      {`Group By: ${children}`}
    </components.SingleValue>
    )
  );

  return (
    <Select
      styles={ groupSelectContext(themeStyles) }
      isSearchable={ false }
      value={ options.filter((opt) => opt.value === groupBy) }
      components={ { SingleValue } }
      placeholder={ <FormattedMessage id={ `${alias}.placeholder` } /> }
      onChange={ (e) => {
        if (e.value.length > 0) {
          setGroupBy(e.value);
        } else {
          clearGroupBy();
        }
      } }
      options={ options.filter((opt) => opt.value !== groupBy) }
    />
  );
}

export default GroupBy;
